import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { CreatorCard } from "./Explore";
import { Loading, Empty, SectionHead } from "../components/common";
import { Briefcase } from "lucide-react";
import { toast } from "sonner";

const ROLES = ["All", "Artist", "Influencer", "Model", "DJ", "Producer", "Videographer", "Photographer", "Director", "Designer", "Streamer", "Dancer", "Actor", "Promoter", "Venue", "Business", "Label"];
const WORLDS = ["All", "Second Life", "IMVU", "FiveM", "VRChat", "Roblox"];

export default function Industry() {
  const [role, setRole] = useState("All");
  const [world, setWorld] = useState("All");
  const [verified, setVerified] = useState(false);
  const [pros, setPros] = useState(null);

  useEffect(() => {
    setPros(null);
    api.get(`/industry?role=${encodeURIComponent(role)}&world=${encodeURIComponent(world)}${verified ? "&verified=true" : ""}`).then(({ data }) => setPros(data));
  }, [role, world, verified]);

  const follow = async (u) => { try { await api.post(`/follow/${u.id}`); toast.success(`Following ${u.display_name}`); } catch { toast.error("Error"); } };

  return (
    <div className="px-4 md:px-6 py-5">
      <div className="flex items-center gap-2 mb-1"><Briefcase className="text-eblue" /><h1 className="font-display font-bold text-2xl">The Industry</h1></div>
      <p className="text-sm text-muted-foreground mb-5">Discover professionals by role. Need a DJ, a videographer, a venue? Find your next collaborator.</p>
      <div className="space-y-3 mb-6">
        <div className="flex gap-2 overflow-x-auto hide-scroll pb-1">{ROLES.map((r) => <button key={r} onClick={() => setRole(r)} data-testid={`industry-role-${r}`} className={`px-3.5 py-1.5 rounded-full text-sm whitespace-nowrap transition-colors ${role === r ? "bg-white text-black" : "surface-2 text-muted-foreground hover:text-white"}`}>{r}</button>)}</div>
        <div className="flex flex-wrap gap-2 items-center">
          {WORLDS.map((w) => <button key={w} onClick={() => setWorld(w)} className={`px-3 py-1 rounded-full text-xs border transition-colors ${world === w ? "border-gold text-gold" : "border-white/10 text-muted-foreground"}`}>{w}</button>)}
          <button onClick={() => setVerified(!verified)} className={`px-3 py-1 rounded-full text-xs border transition-colors ${verified ? "border-eblue text-eblue" : "border-white/10 text-muted-foreground"}`}>Verified only</button>
        </div>
      </div>
      {!pros ? <Loading /> : pros.length === 0 ? <Empty icon={Briefcase} title="No professionals found" hint="Try widening your filters." /> : (
        <><SectionHead title={`${pros.length} ${role === "All" ? "creators" : role + "s"}`} />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">{pros.map((u) => <CreatorCard key={u.id} u={u} onFollow={() => follow(u)} />)}</div>
        </>
      )}
    </div>
  );
}
